import React, { createContext, useContext, ReactNode } from 'react';

interface ClientsContextType {
  clients: string[];
}

const ClientsContext = createContext<ClientsContextType | undefined>(undefined);

interface ClientsProviderProps {
  children: ReactNode;
  clients: string[];
}

export const ClientsProvider: React.FC<ClientsProviderProps> = ({ children, clients }) => {
  return (
    <ClientsContext.Provider value={{ clients }}>
      {children}
    </ClientsContext.Provider>
  );
};

export const useClients = (): ClientsContextType => {
  const context = useContext(ClientsContext);
  if (context === undefined) {
    throw new Error('useClients must be used within a ClientsProvider');
  }
  return context;
}; 